import { routes } from "../../constants/routes";

export const breadcrumbLink = [{
      label: "Lead Qualification",
      link: routes.LEADQUALIFICATION,
       handleClick: () => {},
    },
    {
      label: "Unqualified Leads",
      link: routes.LEADQUALIFICATION,
       handleClick: () => {},
    }];

export const getListingViewBreadcrumbLink = (setViewOpen: any, setSelectedLeadId: any, setCrumbMappingOption: any, leadName: any) => [
      {
        label: "Lead Qualification",
        link: routes.LEADCAPTUREFORM,
        handleClick: () => {
        setViewOpen(false);
        setSelectedLeadId(null);
        setCrumbMappingOption((prev: any) => prev.slice(0, 2));
       },
      },
      {
        label: "Unqualified Leads",
        link: routes.LEADCAPTUREFORM,
        handleClick: () => {
          setViewOpen(false);
          setSelectedLeadId(null);
          setCrumbMappingOption((prev: any) => prev.slice(0, 2));
        },
      },
      { label: leadName, link: "" },
    ];

export const  breadcrumbLinkDuplicateLead = (setIsShowFindDuplicates: any) => [
      {
        label: "Lead Qualification",
        link: routes.LEADCAPTUREFORM,
         handleClick: () => {
          setIsShowFindDuplicates(false);
        },
      },
      {
        label: "Unqualified Leads",
        link: routes.LEADCAPTUREFORM,
        handleClick: () => {
          setIsShowFindDuplicates(false);
        },
      },
      { label: "Duplicate Leads", link: "" },
    ];

export const getListingViewBreadcrumbLinkDuplicateLead = (setViewOpen: any, setSelectedLeadId: any, setCrumbMappingOption: any, leadName: any, setIsShowFindDuplicates: any) => [
      {
        label: "Lead Qualification",
        link: routes.LEADCAPTUREFORM,
        handleClick: () => {
          setIsShowFindDuplicates(false);
          setSelectedLeadId(null);
          setCrumbMappingOption((prev: any) => prev.slice(0, 2));
        },
      },
      {
        label: "Unqualified Leads",
        link: routes.LEADCAPTUREFORM,
        handleClick: () => {
          setIsShowFindDuplicates(false);
          setSelectedLeadId(null);
          setCrumbMappingOption((prev: any) => prev.slice(0, 2));
        },
      },
    {
        label: "Duplicate Leads",
        link: routes.LEADCAPTUREFORM,
        handleClick: () => {
            setViewOpen(false);
          setSelectedLeadId(null);
          setCrumbMappingOption((prev: any) => prev.slice(0, 3));
        },
      },
      { label: leadName, link: "" },
    ]

export const  breadcrumbLinkMergeLeads = (setIsLeadQualificationMergeLeads: any) => [
      {
        label: "Lead Qualification",
        link: routes.LEADCAPTUREFORM,
        handleClick: () => {
          setIsLeadQualificationMergeLeads(false);
        },
      },
      {
        label: "Unqualified Leads",
        link: routes.LEADCAPTUREFORM,
        handleClick: () => {
          setIsLeadQualificationMergeLeads(false);
        },
      },
      { label: "Merge Duplicates", link: "" },
    ];